module.exports = __webpack_public_path__ + "static/img/chengcai3.d8e4c0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/chengcai3.png
// module id = wmsg
// module chunks = 52